// Tag translations: Russian -> English, Turkish
const TAG_MAP = {
  "розы": { en: "roses", tr: "guller" },
  "доставка цветов": { en: "flower delivery", tr: "cicek teslimati" },
  "доставка": { en: "delivery", tr: "teslimat" },
  "цветы": { en: "flowers", tr: "cicekler" },
  "букеты": { en: "bouquets", tr: "buketler" },
  "букет роз": { en: "rose bouquet", tr: "gul buketi" },
  "красные розы": { en: "red roses", tr: "kirmizi guller" },
  "пионы": { en: "peonies", tr: "sakayiklar" },
  "букет пионов": { en: "peony bouquet", tr: "sakayik buketi" },
  "пионовидные розы": { en: "peony roses", tr: "sakayik tipi guller" },
  "сезон пионов": { en: "peony season", tr: "sakayik sezonu" },
  "тюльпаны": { en: "tulips", tr: "laleler" },
  "орхидеи": { en: "orchids", tr: "orkideler" },
  "подсолнухи": { en: "sunflowers", tr: "aycicekleri" },
  "мимоза": { en: "mimosa", tr: "mimoza" },
  "тропические цветы": { en: "tropical flowers", tr: "tropik cicekler" },
  "свадьба": { en: "wedding", tr: "dugun" },
  "свадебная флористика": { en: "wedding floristry", tr: "dugun floristligi" },
  "букет невесты": { en: "bridal bouquet", tr: "gelin buketi" },
  "арка": { en: "arch", tr: "kemer" },
  "оформление": { en: "decoration", tr: "dekorasyon" },
  "день рождения": { en: "birthday", tr: "dogum gunu" },
  "8 марта": { en: "Women's Day", tr: "8 Mart" },
  "женский день": { en: "Women's Day", tr: "Kadinlar Gunu" },
  "14 февраля": { en: "Valentine's Day", tr: "Sevgililer Gunu" },
  "День Валентина": { en: "Valentine's Day", tr: "Sevgililer Gunu" },
  "романтика": { en: "romance", tr: "romantizm" },
  "подарок": { en: "gift", tr: "hediye" },
  "сюрприз": { en: "surprise", tr: "surpriz" },
  "ночная доставка": { en: "night delivery", tr: "gece teslimati" },
  "цветы в коробке": { en: "flowers in box", tr: "kutuda cicekler" },
  "шляпная коробка": { en: "hat box", tr: "sapka kutusu" },
  "цветочные магазины": { en: "flower shops", tr: "cicekler" },
  "сравнение цен": { en: "price comparison", tr: "fiyat karsilastirmasi" },
  "где купить цветы": { en: "where to buy flowers", tr: "cicek nereden alinir" },
  "гид": { en: "guide", tr: "rehber" },
  "отели": { en: "hotels", tr: "oteller" },
  "яхта": { en: "yacht", tr: "yat" },
  "все районы": { en: "all districts", tr: "tum bolgeler" },
  "средиземноморские букеты": { en: "Mediterranean bouquets", tr: "Akdeniz buketleri" },
  "24/7": { en: "24/7", tr: "7/24" },
  // Cities
  "Анталья": { en: "Antalya", tr: "Antalya" },
  "Стамбул": { en: "Istanbul", tr: "Istanbul" },
  "Алания": { en: "Alanya", tr: "Alanya" },
  "Бодрум": { en: "Bodrum", tr: "Bodrum" },
  "Мармарис": { en: "Marmaris", tr: "Marmaris" },
  "Барселона": { en: "Barcelona", tr: "Barcelona" },
  "Аликанте": { en: "Alicante", tr: "Alicante" },
  // Regions/Areas
  "Босфор": { en: "Bosphorus", tr: "Bogaz" },
  "азиатская сторона": { en: "Asian side", tr: "Asya yakasi" },
  "Кадыкёй": { en: "Kadikoy", tr: "Kadikoy" },
  "Ускюдар": { en: "Uskudar", tr: "Uskudar" },
  "Ялыкавак": { en: "Yalikavak", tr: "Yalikavak" },
  "Эгейское море": { en: "Aegean Sea", tr: "Ege Denizi" },
  "Ичмелер": { en: "Icmeler", tr: "Icmeler" },
  "Турунч": { en: "Turunc", tr: "Turunc" },
  "Махмутлар": { en: "Mahmutlar", tr: "Mahmutlar" },
  // Countries
  "Турция": { en: "Turkey", tr: "Turkiye" },
  "Испания": { en: "Spain", tr: "Ispanya" },
  // Spanish
  "Коста Бланка": { en: "Costa Blanca", tr: "Costa Blanca" },
  "Торревьеха": { en: "Torrevieja", tr: "Torrevieja" },
  "Сант Жорди": { en: "Sant Jordi", tr: "Sant Jordi" },
  // Brands
  "David Austin": { en: "David Austin", tr: "David Austin" },
  "Red Naomi": { en: "Red Naomi", tr: "Red Naomi" },
  "Istanbul": { en: "Istanbul", tr: "Istanbul" },
};

export function translateTag(tag, lang) {
  if (lang === "ru") return tag;
  const map = TAG_MAP[tag];
  if (map) return map[lang] || tag;
  return tag;
}

export default TAG_MAP;
